function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  e.setAttribute("role", "button"),
    e.setAttribute("aria-expanded", "false"),
    e.nextElementSibling.getAttribute("id") &&
      e.setAttribute("aria-controls", e.nextElementSibling.id),
    e.addEventListener("click", (e) => {
      e.currentTarget.setAttribute(
        "aria-expanded",
        !e.currentTarget.closest("details").hasAttribute("open")
      );
    }),
    e.closest("header-drawer") ||
      e.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
  var i = getFocusableElements(e),
    s = i[0],
    n = i[i.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target !== e && t.target !== n && t.target !== s) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (t) {
      "TAB" === t.code.toUpperCase() &&
        (t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()),
        (t.target !== e && t.target !== s) ||
          !t.shiftKey ||
          (t.preventDefault(), n.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    t.focus();
}
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const e = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let t = null,
    i = null;
  window.addEventListener("keydown", (t) => {
    e.includes(t.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener("mousedown", (e) => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        t && t.classList.remove("focused"),
          i || ((t = document.activeElement), t.classList.add("focused"));
      },
      !0
    );
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((e) => e.pause()),
    document.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}
function removeTrapFocus(e = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus();
}
function onKeyUpEscape(e) {
  if ("ESCAPE" !== e.code.toUpperCase()) return;
  const t = e.target.closest("details[open]");
  if (!t) return;
  const i = t.querySelector("summary");
  t.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  onButtonClick(e) {
    e.preventDefault();
    const t = this.input.value;
    "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
}
function debounce(e, t) {
  let i;
  return (...s) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
  };
}
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${e}` },
  };
}
customElements.define("quantity-input", QuantityInput),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var n = e.options[i];
      if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i), i;
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener
      ? e.addEventListener(t, i, !1)
      : e.attachEvent("on" + t, i);
  }),
  (Shopify.postLink = function (e, t) {
    var i = (t = t || {}).method || "post",
      s = t.parameters || {},
      n = document.createElement("form");
    for (var r in (n.setAttribute("method", i),
    n.setAttribute("action", e),
    s)) {
      var o = document.createElement("input");
      o.setAttribute("type", "hidden"),
        o.setAttribute("name", r),
        o.setAttribute("value", s[r]),
        n.appendChild(o);
    }
    document.body.appendChild(n), n.submit(), document.body.removeChild(n);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (n =
          this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces"
        ),
        i = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var s = 0; s < i.length; s++) {
          var n;
          ((n = document.createElement("option")).value = i[s][0]),
            (n.innerHTML = i[s][1]),
            this.provinceEl.appendChild(n);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var i = 0;
      for (t.length; i < t.length; i++) {
        var s = document.createElement("option");
        (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
      }
    },
  });
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      "iPhone" === navigator.platform &&
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        ),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((e) =>
      e.addEventListener("click", this.onSummaryClick.bind(this))
    ),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
  }
  onKeyUp(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    const t = e.target.closest("details[open]");
    t &&
      (t === this.mainDetailsToggle
        ? this.closeMenuDrawer(
            e,
            this.mainDetailsToggle.querySelector("summary")
          )
        : this.closeSubmenu(t));
  }
  onSummaryClick(e) {
    const t = e.currentTarget,
      i = t.parentNode,
      s = i.hasAttribute("open"),
      n = window.matchMedia("(prefers-reduced-motion: reduce)");
    function r() {
      trapFocus(t.nextElementSibling, i.querySelector("button")),
        t.nextElementSibling.removeEventListener("transitionend", r);
    }
    i === this.mainDetailsToggle
      ? (s && e.preventDefault(),
        s ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t))
      : setTimeout(() => {
          i.classList.add("menu-opening"),
            t.setAttribute("aria-expanded", !0),
            !n || n.matches
              ? r()
              : t.nextElementSibling.addEventListener("transitionend", r);
        }, 100);
  }
  openMenuDrawer(e) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
        e.removeAttribute("open"), e.classList.remove("menu-opening");
      }),
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      ),
      removeTrapFocus(t),
      this.closeAnimation(this.mainDetailsToggle));
  }
  onFocusOut(e) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(e) {
    const t = e.currentTarget.closest("details");
    this.closeSubmenu(t);
  }
  closeSubmenu(e) {
    e.classList.remove("menu-opening"),
      e.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(e.querySelector("summary")),
      this.closeAnimation(e);
  }
  closeAnimation(e) {
    let t;
    const i = (s) => {
      void 0 === t && (t = s);
      s - t < 400
        ? window.requestAnimationFrame(i)
        : (e.removeAttribute("open"),
          e.closest("details[open]") &&
            trapFocus(e.closest("details[open]"), e.querySelector("summary")));
    };
    window.requestAnimationFrame(i);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(e) {
    (this.header =
      this.header || document.getElementById("shopify-section-header")),
      (this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(e, t) {
    super.closeMenuDrawer(e, t), this.header.classList.remove("menu-open");
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this)
      ),
      this.addEventListener("keyup", (e) => {
        "ESCAPE" === e.code.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (e) => {
            "mouse" !== e.pointerType ||
              e.target.closest("deferred-media, product-model") ||
              this.hide();
          })
        : this.addEventListener("click", (e) => {
            "MODAL-DIALOG" === e.target.nodeName && this.hide();
          });
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(e) {
    this.openedBy = e;
    const t = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      t && t.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden"),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector("button");
    e &&
      e.addEventListener("click", () => {
        const t = document.querySelector(this.getAttribute("data-modal"));
        t && t.show(e);
      });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector('[id^="Deferred-Poster-"]');
    e && e.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(e = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      const t = document.createElement("div");
      t.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0)
      ),
        this.setAttribute("loaded", !0);
      const i = this.appendChild(
        t.querySelector("video, model-viewer, iframe")
      );
      e && i.focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(
        ".slider-counter--current"
      )),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      !this.slider || !this.nextButton)
    )
      return;
    this.initPages();
    new ResizeObserver((e) => this.initPages()).observe(this.slider),
      this.slider.addEventListener("scroll", this.update.bind(this)),
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }
  initPages() {
    (this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (e) => e.clientWidth > 0
    )),
      (this.sliderLastItem =
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]),
      0 !== this.sliderItemsToShow.length &&
        ((this.slidesPerPage = Math.floor(
          this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
        )),
        (this.totalPages =
          this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update());
  }
  resetPages() {
    (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      this.initPages();
  }
  update() {
    const e = this.currentPage;
    (this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != e &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        ),
      this.enableSliderLooping ||
        (this.isSlideVisible(this.sliderItemsToShow[0])
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(this.sliderLastItem)
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled"));
  }
  isSlideVisible(e, t = 0) {
    const i = this.slider.clientWidth + this.slider.scrollLeft - t;
    return (
      e.offsetLeft + e.clientWidth <= i &&
      e.offsetLeft >= this.slider.scrollLeft
    );
  }
  onButtonClick(e) {
    e.preventDefault();
    const t = e.currentTarget.dataset.step || 1;
    (this.slideScrollPosition =
      "next" === e.currentTarget.name
        ? this.slider.scrollLeft + t * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - t * this.sliderLastItem.clientWidth),
      this.slider.scrollTo({ left: this.slideScrollPosition });
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super(),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      (this.enableSliderLooping = !0),
      this.sliderControlWrapper &&
        ((this.sliderFirstItemNode =
          this.slider.querySelector(".slideshow__slide")),
        this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
        )),
        this.sliderControlLinksArray.forEach((e) =>
          e.addEventListener("click", this.linkToSlide.bind(this))
        ),
        this.slider.addEventListener(
          "scroll",
          this.setSlideVisibility.bind(this)
        ),
        this.setSlideVisibility(),
        "true" === this.slider.getAttribute("data-autoplay") &&
          this.setAutoPlay());
  }
  setAutoPlay() {
    (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.play(),
      (this.autoplayButtonIsSetToPlay = !0);
  }
  onButtonClick(e) {
    super.onButtonClick(e);
    const t = 1 === this.currentPage,
      i = this.currentPage === this.sliderItemsToShow.length;
    (t || i) &&
      (t && "previous" === e.currentTarget.name
        ? (this.slideScrollPosition =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth *
              this.sliderItemsToShow.length)
        : i &&
          "next" === e.currentTarget.name &&
          (this.slideScrollPosition = 0),
      this.slider.scrollTo({ left: this.slideScrollPosition }));
  }
  update() {
    super.update(),
      (this.sliderControlButtons = this.querySelectorAll(
        ".slider-counter__link"
      )),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((e) => {
          e.classList.remove("slider-counter__link--active"),
            e.removeAttribute("aria-current");
        }),
        this.sliderControlButtons[this.currentPage - 1].classList.add(
          "slider-counter__link--active"
        ),
        this.sliderControlButtons[this.currentPage - 1].setAttribute(
          "aria-current",
          !0
        ));
  }
  autoPlayToggle() {
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
  }
  focusOutHandling(e) {
    this.autoplayButtonIsSetToPlay && this.play();
  }
  focusInHandling(e) {
    this.autoplayButtonIsSetToPlay && this.pause();
  }
  play() {
    this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(
        this.autoRotateSlides.bind(this),
        this.autoplaySpeed
      ));
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite"),
      clearInterval(this.autoplay);
  }
  autoRotateSlides() {
    const e =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({ left: e });
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((e, t) => {
      const i = e.querySelector("a");
      t === this.currentPage - 1
        ? (i && i.removeAttribute("tabindex"),
          e.setAttribute("aria-hidden", "false"),
          e.removeAttribute("tabindex"))
        : (i && i.setAttribute("tabindex", "-1"),
          e.setAttribute("aria-hidden", "true"),
          e.setAttribute("tabindex", "-1"));
    });
  }
  linkToSlide(e) {
    e.preventDefault();
    const t =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(e.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({ left: t });
  }
}
customElements.define("slideshow-component", SlideshowComponent);
class SlickComponent extends HTMLElement {
  constructor() {
    super(),
      (this.slickWrapper = this.querySelector(
        this.getAttribute("data-slick-wrapper")
      )),
      (this.productsPerRow = parseInt(
        this.getAttribute("data-products-per-row")
      )),
      (this.slidesToScroll = parseInt(
        this.getAttribute("data-slides-to-scroll") || this.getAttribute("data-products-per-row")
      )),
      (this.btnPrev = this.querySelector(".slick-button--prev")),
      (this.btnNext = this.querySelector(".slick-button--next")),
      this.init();
  }
  init() {
    $(this.slickWrapper).slick({
      slidesToShow: this.productsPerRow,
      slidesToScroll: this.slidesToScroll,
      infinite: true,
      dots: !1,
      prevArrow: $(this.btnPrev),
      nextArrow: $(this.btnNext),
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: !1,
          },
        },
      ],
    });
  }
}
customElements.define("slick-component", SlickComponent);
class ProductMediaGallery extends SlickComponent {
  constructor() {
    super();
  }
  init() {
    super.init();
  }
  handleThumbClick(e) {
    let t = e.target;
    for (; "DIV" != t.nodeName; ) t = t.parentNode;
    this.setActiveMedia(t.getAttribute("data-media-id"));
  }
  setActiveMedia(e) {
    const t = this.querySelector(
      `.product-media-gallery__item[data-media-id="${e}"]`
    );
    $(this.slickWrapper).slick(
      "slickGoTo",
      parseInt(t.getAttribute("data-slick-index"))
    );
  }
}
customElements.define("product-media-gallery", ProductMediaGallery);
class GalleryInstagram extends HTMLElement {
  constructor() {
    super(),
      (this.slickWrapper = this.querySelector(
        this.getAttribute("data-slick-wrapper")
      )),
      (this.productsPerRow = parseInt(
        this.getAttribute("data-products-per-row")
      )),
      (this.autoplay = "true" === this.getAttribute("data-autoplay")),
      (this.autoplaySpeed =
        1e3 * parseInt(this.getAttribute("data-autoplay-speed"))),
      (this.btnPrev = this.querySelector(".slick-button--prev")),
      (this.btnNext = this.querySelector(".slick-button--next")),
      (window.onload = this.init.bind(this));
  }
  init() {
    $(this.slickWrapper).slick({
      slidesToShow: this.productsPerRow,
      slidesToScroll: this.productsPerRow,
      infinite: !0,
      dots: !1,
      autoplay: this.autoplay,
      autoplaySpeed: this.autoplaySpeed,
      prevArrow: $(this.btnPrev),
      nextArrow: $(this.btnNext),
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: !0,
            dots: !1,
          },
        },
      ],
    });
  }
}
customElements.define("gallery-instagram-component", GalleryInstagram);
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateURL(),
          this.updateVariantInput(),
          this.renderProductInfo(),
          this.updateShareUrl())
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (e) => e.value);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
    );
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const e = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (e) {
      e.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        !0
      );
      const t = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`
        ),
        i = t.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`
        );
      t.prepend(i);
    } else {
      const e = document.getElementById(
        `ProductMediaGallery-${this.dataset.section}`
      );
      e &&
        e.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`
        );
    }
  }
  updateURL() {
    this.currentVariant &&
      "false" !== this.dataset.updateUrl &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateShareUrl() {
    const e = document.getElementById(`Share-${this.dataset.section}`);
    e &&
      e.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateVariantInput() {
    document
      .querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`
      )
      .forEach((e) => {
        const t = e.querySelector('input[name="id"]');
        (t.value = this.currentVariant.id),
          t.dispatchEvent(new Event("change", { bubbles: !0 }));
      });
  }
  updatePickupAvailability() {
    const e = document.querySelector("pickup-availability");
    e &&
      (this.currentVariant && this.currentVariant.available
        ? e.fetchAvailability(this.currentVariant.id)
        : (e.removeAttribute("available"), (e.innerHTML = "")));
  }
  removeErrorMessage() {
    const e = this.closest("section");
    if (!e) return;
    const t = e.querySelector("product-form");
    t && t.handleErrorMessage();
  }
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((e) => e.text())
      .then((e) => {
        const t = [`price-${this.dataset.section}`, "selected-color-name"];
        for (let i = 0; i < t.length; i++) {
          const s = t[i],
            n = new DOMParser().parseFromString(e, "text/html"),
            r = document.getElementById(s),
            o = n.getElementById(s);
          if ((o && r && (r.innerHTML = o.innerHTML), s.includes("price"))) {
            const e = document.getElementById(`price-${this.dataset.section}`);
            e && e.classList.remove("visibility-hidden"),
              this.toggleAddButton(
                !this.currentVariant.available,
                window.variantStrings.soldOut
              );
          }
        }
      });
  }
  toggleAddButton(e = !0, t, i = !0) {
    const s = document.getElementById(`product-form-${this.dataset.section}`);
    if (!s) return;
    const n = s.querySelector('[name="add"]'),
      r = s.querySelector('[name="add"] > span');
    n &&
      (e
        ? (n.setAttribute("disabled", "disabled"), t && (r.textContent = t))
        : (n.removeAttribute("disabled"),
          (r.textContent = window.variantStrings.addToCart)));
  }
  setUnavailable() {
    const e = document.getElementById(`product-form-${this.dataset.section}`),
      t = e.querySelector('[name="add"]'),
      i = e.querySelector('[name="add"] > span'),
      s = document.getElementById(`price-${this.dataset.section}`);
    t &&
      ((i.textContent = window.variantStrings.unavailable),
      s && s.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  updateOptions() {
    const e = Array.from(this.querySelectorAll("fieldset"));
    this.options = e.map(
      (e) =>
        Array.from(e.querySelectorAll("input")).find((e) => e.checked).value
    );
  }
}
customElements.define("variant-radios", VariantRadios);
class ProductReviews extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    (this.reviewsSlider = this.querySelector(".spr-reviews")),
      (this.reviewItems = this.querySelectorAll(".spr-review"));
    const e = this.querySelector(".spr-summary-caption"),
      t = this.querySelector(".spr-summary-actions-togglereviews");
    e && !t
      ? this.remove()
      : this.reviewsSlider && this.reviewItems && 0 != this.reviewItems.length
      ? ((this.btnPrev = this.querySelector(".product-reviews__prev")),
        (this.btnNext = this.querySelector(".product-reviews__next")),
        (this.currentPage = this.querySelector(
          ".product-reviews__current-page"
        )),
        (this.pagesCount = this.querySelector(".product-reviews__pages-count")),
        this.initSlideshow())
      : setTimeout(() => {
          this.init();
        }, 100);
  }
  initSlideshow() {
    $(this.reviewsSlider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: !0,
      dots: !1,
      prevArrow: $(this.btnPrev),
      nextArrow: $(this.btnNext),
    }),
      (this.pagesCount.innerHTML = `${this.reviewItems.length}`),
      $(this.reviewsSlider).on(
        "afterChange",
        this.handleReviewChange.bind(this)
      ),
      setTimeout(() => {
        this.classList.add("loaded");
      }, 100);
  }
  handleReviewChange(e, t, i) {
    this.currentPage.innerHTML = `${i + 1}`;
  }
}
customElements.define("product-reviews", ProductReviews);
class VideoComponent extends HTMLElement {
  constructor() {
    super(),
      (this.videoElement = this.querySelector("video")),
      (this.playBtn = this.querySelector(
        ".video-section__play-overlay__inner"
      )),
      (this.videoModal = this.querySelector(".video-component-modal")),
      (this.modalInner = this.querySelector(".video-component-modal__inner")),
      (this.videoId = this.modalInner.getAttribute("data-video-id")),
      this.init();
  }
  init() {
    this.playBtn.addEventListener("click", this.openModal.bind(this)),
      this.modalInner.addEventListener("click", this.closeModal.bind(this)),
      document.querySelector("main").append(this.videoModal);
  }
  openModal(e) {
    const t = $(
      `<iframe \n      class="vimeo-iframe"\n      src="https://player.vimeo.com/video/${this.videoId}?byline=0&portrait=0"\n      frameborder="0"\n      allow="autoplay; fullscreen; picture-in-picture"\n      allowfullscreen\n    ></iframe>`
    );
    $(this.modalInner).append(t),
      (this.videoModal.style.display = "block"),
      setTimeout(() => {
        this.videoModal.classList.add("open"), new Vimeo.Player(t[0]).play();
      }, 10);
  }
  closeModal(e) {
    this.videoModal.classList.remove("open"),
      setTimeout(() => {
        (this.videoModal.style.display = "none"), $(this.modalInner).empty();
      }, 450);
  }
}
customElements.define("video-component", VideoComponent);
/* ===== Bundle color label updater — safe ===== */

(function () {

  function updateColorLabels(fieldset) {
    if (!fieldset) return;

    const selected = fieldset.querySelector('input[type="radio"]:checked');
    const label = fieldset.querySelector('.selected-color-name');

    if (selected && label) {
      label.textContent = selected.value;
    }
  }

  function initBundleColorListeners() {

    const productTitle = document.querySelector('.product__title')?.textContent || '';
    if (!productTitle.includes('Kit Workplace')) return;

    const fieldsets = document.querySelectorAll('fieldset.product-form__input[data-is-color="true"]');

    fieldsets.forEach(fieldset => {

      // valor inicial ao carregar
      updateColorLabels(fieldset);

      // quando clicar numa cor
      fieldset.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) {
          updateColorLabels(fieldset);
        }
      });

    });
  }

  document.addEventListener('DOMContentLoaded', initBundleColorListeners);

})();
